import { setHtml } from './http';

const PERIODS = ['week', 'month', 'year'];

function periodFromUrl() {
  const period = new URLSearchParams(window.location.search).get('period');
  return PERIODS.includes(period) ? period : 'month';
}

// The dashboard's Site overview panel (Features/SiteOverview). Loads after the
// page so slow tracking queries don't hold up the rest of the dashboard, and
// swaps the panel when a period is picked. The period lives in the URL, so a
// view can be shared and Back returns to the previous period.
export default () => ({
  period: periodFromUrl(),
  loading: false,
  failed: false,

  init() {
    this.load(this.period, false);
    window.addEventListener('popstate', () => this.load(periodFromUrl(), false));
  },

  async load(period, remember = true) {
    this.period = period;
    this.loading = true;
    this.failed = false;

    try {
      const response = await fetch(`/site-overview?period=${encodeURIComponent(period)}`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) {
        throw new Error(`Overview failed: ${response.status}`);
      }

      const html = await response.text();

      // A later click may have changed the period while this one was loading.
      if (period !== this.period) {
        return;
      }

      setHtml(this.$refs.body, html);

      if (remember && periodFromUrl() !== period) {
        const url = new URL(window.location.href);
        url.searchParams.set('period', period);
        window.history.pushState(null, '', url);
      }
    } catch {
      this.failed = true;
    } finally {
      if (period === this.period) {
        this.loading = false;
      }
    }
  },
});
